import { cloneElement, ReactElement, useContext, useMemo } from 'react';
import {
    CreateButton,
    ExportButton,
    FilterButton,
    FilterContext,
    ListActionsProps,
    sanitizeListRestProps,
    TitlePortal,
    TopToolbar,
    useListContext,
    useResourceContext,
    useResourceDefinition,
} from 'react-admin';
import { mergeSx } from '../../../utils';
import { Stack } from '@mui/material';
import { ListContext } from 'react-admin';

const defaultSelectedIds: string[] | number[] = [];
const defaultOnUnselectItems = () => null;



const ListActionsInner = (
    props: ListActionsProps & { extraActions?: ReactElement }
) => {
    const {
        className,
        filters: filtersProp,
        hasCreate: _,
        selectedIds = defaultSelectedIds,
        onUnselectItems = defaultOnUnselectItems,
        extraActions,
        exporter: propsExporter,
        ...rest
    } = props;
    const {
        sort,
        displayedFilters,
        filterValues,
        exporter = propsExporter,
        showFilter,
        total,
    } = useListContext(); //{ ...props, selectedIds, onUnselectItems }
    const resource = useResourceContext(props);
    const { hasCreate } = useResourceDefinition(props);
    const filters = useContext(FilterContext) || filtersProp;
    return useMemo(
        () => (
            <TopToolbar
                className={className}
                {...sanitizeListRestProps(rest)}
                sx={[
                    {
                        width: 1,
                        p: 0,
                        pl: 3,
                        mb: 2,
                        flexDirection: {
                            xs: 'column',
                            md: 'row',
                        },
                        alignItems: {
                            xs: 'stretch',
                            md: 'center',
                        },
                    },
                    ...mergeSx(props.sx as any),
                ]}
            >
                <TitlePortal variant={'h1'} sx={{ flexShrink: 0, flexGrow: 0, overflow: 'visible' }} />

                <Stack
                    flexDirection={'row'}
                    justifyContent={'flex-end'}
                    gap={1}
                    flexGrow={1}
                    flexWrap={'wrap-reverse'}
                >
                    {filtersProp
                        ? cloneElement(filtersProp, {
                              resource,
                              showFilter,
                              displayedFilters,
                              filterValues,
                              context: 'button',
                          })
                        : filters && <FilterButton />}

                    {extraActions}

                    {exporter !== false && (
                        <ExportButton
                            disabled={total === 0}
                            resource={resource}
                            sort={sort}
                            filterValues={filterValues}
                            size={'medium'}
                        />
                    )}
                    {hasCreate && (
                        <CreateButton variant={'contained'} size={'medium'} />
                    )}
                </Stack>
            </TopToolbar>
        ),
        /* eslint-disable react-hooks/exhaustive-deps */
        [
            resource,
            displayedFilters,
            filterValues,
            filtersProp,
            showFilter,
            filters,
            total,
            className,
            sort,
            exporter,
            hasCreate,
            extraActions,
        ]
    );
};

export const ListActions = (props: any) => {
    const context = useContext(ListContext);
    if (context) {
        return <ListActionsInner {...props} />
    }

    return <ListContext.Provider value={{  } as any}>
        <ListActionsInner {...props} />
    </ListContext.Provider>

}
